/* Keep EasySell's pending COD order intact while showing the custom offer page. */
(() => {
  'use strict';

  if (window.VeloraaUpsellBridge || window.top !== window) return;

  const STORAGE_KEY = 'vl_postpurchase_upsell_v2';
  const OFFER_PATH = '/pages/oferta-exclusiva-bandas';
  const OFFER_PRODUCT_ID = '11564047696213';
  const themeId = null;
  const state = { order: null, funnelData: null, hash: null, redirected: false };
  window.VeloraaUpsellBridge = state;

  // Capture the order/new response without changing the data EasySell receives.
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    let isOrderNew = false;
    try {
      const requestUrl = new URL(args[0] instanceof Request ? args[0].url : String(args[0]), location.href);
      isOrderNew = requestUrl.hostname === 'load.tyslo.com' && requestUrl.pathname === '/order/new';
      if (isOrderNew && typeof args[1]?.body === 'string') {
        const submitted = JSON.parse(args[1].body);
        if (typeof submitted.hash === 'string' && submitted.hash) state.hash = submitted.hash;
      }
    } catch (_) { /* Leave other fetch calls untouched. */ }
    return originalFetch.apply(this, args).then(async response => {
      if (isOrderNew) {
        try {
          const data = await response.clone().json();
          if (data && data.success && data.funnel_data) {
            state.funnelData = data.funnel_data;
            if (data.order) state.order = data.order;
            // Redirect as soon as EasySell confirms the pending order.
            tryRedirect();
          }
        } catch (_) { /* EasySell still handles its original response. */ }
      }
      return response;
    });
  };

  const previousPurchaseHook = window.es_hook_purchase_success;
  window.es_hook_purchase_success = function (order) {
    if (typeof previousPurchaseHook === 'function') {
      try { previousPurchaseHook.apply(this, arguments); } catch (error) { console.error('EasySell purchase hook:', error); }
    }
    if (order && order.id && order.order_status_url && Array.isArray(order.line_items)) {
      state.order = order;
      queueMicrotask(tryRedirect);
    }
  };

  function chosenOffer() {
    const data = state.funnelData;
    if (!data || !data.funnel || !Array.isArray(data.funnel.offers)) return null;
    return data.funnel.offers.find(offer => String(offer.product && offer.product.id).split('/').pop() === OFFER_PRODUCT_ID) || null;
  }


  function tryRedirect() {
    if (state.redirected || !document.body) return;
    if (!state.order && window.ES_FINAL_ORDER) state.order = window.ES_FINAL_ORDER;

    const offer = chosenOffer();
    const data = state.funnelData;
    const pendingOrder = data?.pending_order === true;
    if (!pendingOrder && !state.order) return;
    if (!offer || !(data.hash || state.hash) || (!pendingOrder && !data.graphql_id) || !data.funnel.id || !offer.id || !offer.product.handle) return;

    const customerName = document.querySelector('#es-first_name')?.value || state.order?.customer?.first_name || '';
    const confirmation = new URL('/pages/gracias', location.origin);
    if (customerName) confirmation.searchParams.set('c', customerName);
    if (themeId) confirmation.searchParams.set('preview_theme_id', themeId);
    const testTimeout = themeId === '204487983445' && new URLSearchParams(location.search).get('vl_test_timeout') === '15';

    const record = {
      version: 3,
      createdAt: Date.now(),
      deadline: Date.now() + (testTimeout ? 15000 : 4 * 60 * 1000),
      pendingOrder,
      orderId: state.order?.id ? String(state.order.id) : null,
      orderStatusUrl: state.order?.order_status_url || null,
      confirmationUrl: confirmation.href,
      shop: window.Shopify?.shop,
      currency: window.Shopify?.currency?.active || 'EUR',
      funnelId: data.funnel.id,
      offerId: offer.id,
      offerProductId: offer.product.id,
      productHandle: offer.product.handle,
      discount: offer.settings?.discount,
      graphqlId: data.graphql_id,
      hash: data.hash || state.hash,
      status: 'pending'
    };
    if (!record.shop || !record.discount) return;
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(record)); } catch (_) { return; }

    state.redirected = true;
    const url = new URL(OFFER_PATH, location.origin);
    url.searchParams.set('vl_upsell', '1');
    if (themeId) url.searchParams.set('preview_theme_id', themeId);
    location.assign(url.href);
  }

  new MutationObserver(tryRedirect).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['style']
  });
})();
